<template>
    <div class="akapp">
        <!--<div class="crumb">-->
            <!--<a href="/">首页</a> &gt; APP-->
        <!--</div>-->
        <div class="apps">
            <div class="pwa">
                <div class="title">PWA(渐进式网页应用)</div>
                <div class="content">
                    <img src="../assets/images/ios-pwa.png" class="app-img">
                    <p style="color: #999999;font-size: 0.9rem;padding: 15px 40px">对于iPhone用户用Safari打开本站首页，点击中间分享按钮，然后选择"添加到主屏幕"，然后您就可以以跟APP无差别的体验浏览本站了，不会再有用手机浏览器点击链接跳过来跳过去的烦恼(需要iPhone升级到12.2)</p>
                    <p style="color: #999999;font-size: 0.9rem;padding: 15px 40px">对于Android用户不同厂商对于PWA的技术支持差异较大，个人手头设备有限，如果大家如果发现哪个厂商的ROM对PWA技术支持较好欢迎反馈，我会补充到这里</p>
                </div>
            </div>
            <div class="android">
                <div class="title">Android(Beta版)</div>
                <div class="content">
                    <img src="../assets/images/appdl.png" class="app-img">
                    <p style="color: #999999;font-size: 0.9rem;padding: 15px">或</p>
                    <a href="https://www.anyknew.com/app/dl" style="color: #3DB4F1;font-size: 1rem">点我下载</a>
                    <p style="color: #999999;font-size: 0.9rem;padding: 15px 40px">如果您在使用手机浏览器访问本站，点击查看详情时感觉网页来回切换很繁琐，用APP试下吧，会让您的浏览舒适度大增</p>
                </div>
            </div>
            <div class="ios">
                <div class="title">iOS</div>
                <div class="content">
                    <img src="https://f0.anyknew.com/static/img/iosak01.png" class="app-img">
                    <p style="color: #999999;font-size: 0.9rem;padding: 15px 40px">该iOS应用由用户Kuntanury提供，<a href="https://github.com/Kuntanury/AnyKnew" ref="nofollow" style="color: #3DB4F1" target="_blank">Github地址</a>，需要自行打包安装，如果熟悉iOS开发更喜欢这种布局的话推荐使用😄</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
  export default {
    name: "akapp",
    data() {
      return {
        srcItemNum: 5,
        descItemNum: 5,
        cats: [],
        cwidth: 105,
        newCatName: '',
        userCats: [],
        // catCount: 0,
        addingCat: true,
        srcSitesPos: {}, // 缓存每个网站的位置，便于从初始数据构建出userCats
        showingHelp: false,
      }
    },
  }
</script>

<style lang="less">
.akapp{
    .crumb{
        margin: 20px auto;
        width: 1120px;
        /*height: 30px;*/
        border-radius: 5px;
        font-size: 1rem;
        /*background-color: #FFFFFF;*/

    }
    .apps{
        /*display: flex;*/
        /*align-items: center;*/
        /*justify-content: space-between;*/
        /*width: 1120px;*/
        /*min-height: 100%;*/
        display: block;
        width: 100%;
        margin: 20px auto;

        .pwa{
            max-width: 750px;
            margin: auto;
            border-radius: 5px;
            background-color: #FFFFFF;
            .title{
                text-align: center;
                font-size: 1.2rem;
                padding: 10px 0;
            }
            .content{
                text-align: center;
                .app-img{
                    width: 200px;
                }
            }
        }

        .android{
            max-width: 750px;
            margin: auto;
            margin-top: 20px;
            border-radius: 5px;
            background-color: #FFFFFF;
            .title{
                text-align: center;
                font-size: 1.2rem;
                padding: 10px 0;
            }
            .content{
                text-align: center;
                .app-img{
                    width: 200px;
                }
            }
        }
        .ios{
            max-width: 750px;
            margin: auto;
            margin-top: 20px;
            border-radius: 5px;
            background-color: #FFFFFF;
            .title{
                text-align: center;
                font-size: 1.2rem;
                padding: 10px 0;
            }
            .content{
                text-align: center;
                .app-img{
                    width: 280px;
                }
            }
        }
    }
}
</style>